import React from "react";
import {
  SettingsOptionContainer,
  SettingsOptionHeading,
} from "../../../styles";
import { useTranslation } from "react-i18next";
import OrganizationItem from "./OrganizationItem";
import StructuredList from "../tree/StructuredList";

function Manual() {
  const { t } = useTranslation();

  return (
    <>
      <SettingsOptionContainer>
        <SettingsOptionHeading>
          {t("add-people-to-organization-chart")}
        </SettingsOptionHeading>

        <OrganizationItem />
      </SettingsOptionContainer>
      <StructuredList />
    </>
  );
}

export default Manual;
